import { Link } from "react-router-dom";
import { Zap, Mail, ShieldAlert } from "lucide-react";
import { SITE, NAV_LINKS, AFFILIATION, LEGAL } from "@/data/site";

export const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-[#080808]" data-testid="main-footer">
      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2 max-w-sm">
          <Link to="/" className="inline-flex items-center mb-5">
            <img src="/logo.png" alt="TopAffiliation" className="h-10 w-auto" />
          </Link>
          <p className="text-white/60 text-sm leading-relaxed">
            {SITE.tagline}. Offriamo le migliori campagne di affiliazione con CPA e
            Revenue tra le più alte del web su scommesse, casinò e trading. Costruisci
            oggi la tua rendita passiva con un leader di mercato.
          </p>
          <a
            href={`mailto:${SITE.email}`}
            data-testid="footer-email"
            className="mt-5 inline-flex items-center gap-2 text-sm text-white/80 hover:text-brand-red transition-colors"
          >
            <Mail className="h-4 w-4" /> {SITE.email}
          </a>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-sm uppercase tracking-widest text-white/50 mb-4">
            Navigazione
          </h4>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-sm text-white/70 hover:text-brand-red transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <a
                href={AFFILIATION.signup}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-white/70 hover:text-brand-red transition-colors"
              >
                Registrati
              </a>
            </li>
            <li>
              <a
                href={AFFILIATION.login}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-white/70 hover:text-brand-red transition-colors"
              >
                Accedi
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-sm uppercase tracking-widest text-white/50 mb-4">
            Legale
          </h4>
          <ul className="space-y-3">
            <li>
              <a
                href={LEGAL.privacy}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-privacy"
                className="text-sm text-white/70 hover:text-brand-red transition-colors"
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                href={LEGAL.termini}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-termini"
                className="text-sm text-white/70 hover:text-brand-red transition-colors"
              >
                Termini e Condizioni
              </a>
            </li>
            <li>
              <Link
                to="/decreto-dignita"
                data-testid="footer-decreto"
                className="text-sm text-white/70 hover:text-brand-red transition-colors"
              >
                Decreto Dignità
              </Link>
            </li>
            <li>
              <Link
                to="/cookie-policy"
                data-testid="footer-cookie-policy"
                className="text-sm text-white/70 hover:text-brand-red transition-colors"
              >
                Cookie Policy
              </Link>
            </li>
            <li>
              <Link
                to="/contatti"
                className="text-sm text-white/70 hover:text-brand-red transition-colors"
              >
                Contatti
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} {SITE.name}. Tutti i diritti riservati.
          </p>
          <div className="flex items-center gap-2 text-xs text-white/50">
            <ShieldAlert className="h-4 w-4 text-brand-red" />
            <span>
              Il gioco è vietato ai minori di 18 anni e può causare dipendenza patologica.
              Gioca responsabilmente.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
